import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'service/hooks/queryKeys'
import endpoint from 'service/api/products/index'
import { useAtom } from 'jotai'
import { googleCredentialAtom } from 'store/atoms'

const useGetProductsByName = (args: { name: string }) => {
  const [googleCredential] = useAtom(googleCredentialAtom)
  return useQuery({
    queryKey: [QueryKey.GET_PRODUCTS_BY_NAME, args],
    queryFn: () =>
      endpoint({
        params: { ...args, 'google-token': googleCredential?.credential }
      }),
    select: response => response.data,
    enabled: !!args.name
  })
}

export { useGetProductsByName }
